import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
import { FileUploadService } from 'src/app/services/file-upload.service';

@Component({
  selector: 'app-upload-data',
  templateUrl: './upload-data.component.html',
  styleUrls: ['./upload-data.component.css']
})
export class UploadDataComponent implements OnInit {
  fileToUpload: File = null;
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  migration_list: any = [
    {
      "displayName": "Patients",
      "value": "Patients"
    },
    {
      "displayName": "Appointments",
      "value": "Appointments"
    },
    {
      "displayName": "Notes",
      "value": "Notes"
    },
    {
      "displayName": "Item",
      "value": "SPItems"
    },
    {
      "displayName": "Order Catelog Items",
      "value": "CatalogItems"
    },
    {
      "displayName": "Inventory Catelog Items",
      "value": "InventoryItems"
    },
    {
      "displayName": "CRM Leads",
      "value": "CRMLeads"
    },
    {
      "displayName": "Stock Adjust",
      "value": "StockAdjust"
    },
    {
      "displayName": "Members",
      "value": "Members"
    },
     {
      "displayName": "Reservations",
      "value": "IPReservations"
    },
  ]
  public uploadForm: UntypedFormGroup
  catelogDetails: any;
  constructor(private fileuploadService: FileUploadService,
    private formbuilder: UntypedFormBuilder,
    private accountService: AccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
   
    this.createForm();
  }
  createForm() {
    this.uploadForm = this.formbuilder.group({
      migrationType: ['Patients'],
      category: ''
    });
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }
 
  uploadFile() {
    console.log(this.fileToUpload)
    if (this.fileToUpload === null) {
      this.api_error = 'Please choose file';
      setTimeout(() => {
        this.api_error = '';
      }, 2000);
    }
    else {
      this.api_error = '';
      this.api_success = '';
      this.disableConfirmbtn = false;
      this.fileuploadService.uploadFile(this.fileToUpload, this.data, this.uploadForm.get('migrationType').value)
        .subscribe(
          res => {
            const errorMessages: string[] = Object.keys(res).map(key => `${key}: "${res[key]}"`);
            const firstErrorMessage: string = errorMessages[0];
            const parts = firstErrorMessage.split(": ");
            const firstPart = parts[0];
            const secondPart = parts[1];
            if(firstPart !== this.data){
              this.api_error = errorMessages;
              setTimeout(() => {
                this.api_error = '';
              }, 4000);
            }else{
              this.api_success = 'Uploaded Successfully';
              setTimeout(() => {
                this.dialogRef.close('reloadlist');
              }, 2000);
            }
          
          },
          error => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
          }
        );
    }

  }
}
